<p-toast key="global" position="top-right">
  <ng-template pTemplate="message" let-message>
    @if (message.data?.type === 'upload-progress') {
      <div class="upload-toast">
        <div class="upload-toast__header">
          <div class="upload-toast__title">{{ message.summary }}</div>
          <button
            pButton
            type="button"
            class="p-button-text p-button-sm"
            label="Cancelar"
            (click)="confirmCancel($event)"
          ></button>
        </div>

        <div class="upload-toast__body">
          <div class="upload-toast__meta">
            <span>{{ (uploadManager.state$ | async)?.completedFiles ?? 0 }}/{{ (uploadManager.state$ | async)?.totalFiles ?? 0 }}</span>
            <span>{{ (uploadManager.state$ | async)?.progress ?? 0 }}%</span>
          </div>
          <p-progressbar [value]="(uploadManager.state$ | async)?.progress ?? 0"></p-progressbar>
        </div>
      </div>
    } @else {
      <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">{{ message.detail }}</div>
      </div>
    }
  </ng-template>
</p-toast>

<p-toast key="orthophoto-upload" position="top-right">
  <ng-template pTemplate="message" let-message>
    @if (message.data?.type === 'orthophoto-upload-progress') {
      @if (orthophotoUploadManager.state$ | async; as orto) {
        <div class="upload-toast">
          <div class="upload-toast__header">
            <div class="upload-toast__title">{{ message.summary }}</div>
            <button
              pButton
              type="button"
              class="p-button-text p-button-sm"
              label="Cancelar"
              (click)="confirmCancelOrthophoto($event)"
            ></button>
          </div>
          <div class="upload-toast__body">
            <div class="upload-toast__phase text-xs opacity-90 mb-1">{{ orto.phaseLabel }}</div>
            @if (orto.folderName) {
              <div class="upload-toast__filename text-xs truncate mb-1" [title]="orto.folderName">
                {{ orto.folderName }}
              </div>
            }

            <div class="upload-toast__meta">
              <span>{{ orto.completedTiles }} / {{ orto.totalTiles }} tiles</span>
              <span>{{ orto.progress }}%</span>
            </div>
            <p-progressbar [value]="orto.progress"></p-progressbar>
          </div>
        </div>
      }
    } @else {
      <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">{{ message.detail }}</div>
      </div>
    }
  </ng-template>
</p-toast>

<p-toast key="pdf-generation" position="top-right">
  <ng-template pTemplate="message" let-message>
    @if (message.data?.type === 'pdf-generation-progress') {
      @if (pdfGenerationManager.state$ | async; as pdf) {
        <div class="upload-toast">
          <div class="upload-toast__header">
            <div class="upload-toast__title">
              {{ message.summary }}
              @if (pdf.lineLabel) {
                <span class="text-xs opacity-80 ml-2">{{ pdf.lineLabel }}</span>
              }
            </div>
            <button
              pButton
              type="button"
              class="p-button-text p-button-sm"
              label="Cancelar"
              (click)="confirmCancelPdf($event)"
            ></button>
          </div>
          <div class="upload-toast__body">
            <div class="upload-toast__phase text-xs opacity-90 mb-1">{{ pdf.phaseLabel }}</div>
            <div class="upload-toast__meta">
              <span></span>
              <span>{{ pdf.progress }}%</span>
            </div>
            <p-progressbar [value]="pdf.progress"></p-progressbar>
          </div>
        </div>
      }
    } @else {
      <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">{{ message.detail }}</div>
      </div>
    }
  </ng-template>
</p-toast>